import styles from "./AdditionalSelectionQuestionsSection.module.css"
import qusetionImg from "../../images/questionImg.png"
import { useState } from "react"

export default function AdditionalQuestionsSection(){
  const [openedElement, setOpenedElement] = useState(null);
  const handleButtonClick = (elId) => {
    setOpenedElement(openedElement === elId? null: elId)
  }
  return(
    <div className={styles.addQuestSec}>
        <div className={styles.addQuestSec__titleContainer}>
          <img className={styles.addQuestSec__titleImg} src={qusetionImg} alt="Дополнительные вопросы" />
          <h4 className={styles.addQuestSec__title}>Еще остались вопросы по подбору автомобиля?</h4>
        </div>
        <div className={styles.list}>
          <ul className={styles.list__ul}>

            <li className={styles.list__li} onClick={() => handleButtonClick(1)}>
              <div className={styles.list__liInnerContainer}>
                <p>Почему стоит обратиться в компанию по подбору авто?</p>
                <button className={styles.list__button} >
                  <p className={styles.list__buttonPlus}>+</p>
                </button>
              </div>
              <p className={`${styles.list__text} ${openedElement === 1? styles.list__text_visible : styles.list__text}`}>
                Обратившись к нам, вы сэкономите время и силы, получив профессиональную помощь на всех этапах. 
                Мы подбираем автомобили под ваши требования, проверяем их техническое состояние и юридическую чистоту, а также торгуемся за лучшую цену. 
                С нами вы получите надёжный автомобиль без лишних хлопот.
              </p>
            </li>
            <li className={styles.list__li} onClick={() => handleButtonClick(2)}>
              <div className={styles.list__liInnerContainer}>
                <p>Как происходит подбор авто?</p>
                <button className={styles.list__button} >
                  <p className={styles.list__buttonPlus}>+</p>
                </button>
              </div>
              <p className={`${styles.list__text} ${openedElement === 2? styles.list__text_visible : styles.list__text}`}>
                Подбор автомобиля начинается с консультации, где мы уточняем ваши требования и заключаем договор. 
                Далее мы анализируем рынок, подбираем подходящие варианты, проверяем их техническое состояние и юридическую чистоту. После этого организуем осмотр автомобиля, сопровождаем сделку и помогаем с оформлением. 
                Вы получаете проверенный автомобиль, готовый к эксплуатации.
              </p>
            </li>
            <li className={styles.list__li} onClick={() => handleButtonClick(3)}>
              <div className={styles.list__liInnerContainer}>
                <p>Сколько времени вам нужно на подбор автомобиля?</p>
                <button className={styles.list__button}>
                  <p className={styles.list__buttonPlus}>+</p>
                </button>
              </div>
              <p className={`${styles.list__text} ${openedElement === 3? styles.list__text_visible : styles.list__text}`}>
                Срок подбора зависит от требований клиента. При поиске под заказ процесс занимает от 1–30 дней, в зависимости от бюджета, модели и состояния авто. 
                Мы тщательно проверяем каждый автомобиль, чтобы предложить лучший вариант
              </p>
            </li>
            <li className={styles.list__li} onClick={() => handleButtonClick(5)}>
              <div className={styles.list__liInnerContainer}>
                <p>Чем вы лучше конкурентов?</p>
                <button className={styles.list__button} >
                  <p className={styles.list__buttonPlus}>+</p>
                </button>
              </div>
              <p className={`${styles.list__text} ${openedElement === 5? styles.list__text_visible : styles.list__text}`}>
                Мы тщательно проверяем каждое авто по базам и техническому состоянию, подбираем только честные варианты без скрытых дефектов. 
                Работаем быстро, учитываем все пожелания клиента и предлагаем лучшее соотношение цены и качества. 
                Оформляем безопасную сделку без переплат и скрытых комиссий.
              </p>
            </li>
            <li className={styles.list__li} onClick={() => handleButtonClick(7)}>
              <div className={styles.list__liInnerContainer}>
                <p>Почему стоит обратиться в компанию по подбору авто?</p>
                <button className={styles.list__button}>
                  <p className={styles.list__buttonPlus}>+</p>
                </button>
              </div>
              <p className={`${styles.list__text} ${openedElement === 7? styles.list__text_visible : styles.list__text}`}>
                Покупка авто – это риск, особенно на вторичном рынке. 
                Мы помогаем избежать проблем, проверяя машину по базам, техническому состоянию и юридической чистоте. 
                Экономим ваше время и деньги, подбирая надежный и проверенный вариант по лучшей цене.
              </p>
            </li>
          </ul>
        </div>
    </div>
  )
}